import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {
  RaisedButton, Card, CardText, Table, TableHeader, TableRow, CardHeader,
  TableHeaderColumn, TableBody, TableRowColumn, Dialog, FlatButton, IconButton, CircularProgress,
} from "material-ui";
import { } from "../../Global/actions";
import {
  ModalSolicitudReajustePaso, ModalConfirmarSolicitarReajuste, InsertReajuste, ModalSolicitudReajusteLoading,
  CargaCombinacionesReajuste, ModalAceptarOpen, CambiarItemsEliminados, ValidarGruposSolicitudEnCurso, IniciarValidacionesReplicacionSolicitud,
  ValidarGruposSolicitudEnCursoPQ, LoadingValidacion, IniciarValidacionesReplicacionSolicitudPQ, InsertReajustePQ,
  CargarSolicitudesEnCurso, CargarSolicitudesEnCursoReplicaArancel, CargarVigenciasNoExistentesReplica, SetLoadingValidacionSolicitudEnCurso
} from "../SolicitudReajuste/actions";
import HistorialReajustes from "../HistorialReajustes/view";
import styles from "../../styles/styles";
import urlHelper from "../../../helpers/urlHelper";


class SolicitudReajusteConfirmacion extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalSolicitudEnCurso: false,
      modalSolicitudEnCursoAux: false,
      modalConfirmarSolicitarReajusteAux: false,

    };
  }

  componentWillMount() {
    this.props.dispatch(ModalSolicitudReajusteLoading(true));
    this.props.dispatch(CargaCombinacionesReajuste(this.props.itemsSolicitudReajuste));
    this.props.dispatch(LoadingValidacion(true));
    if (this.props.periodoReajuste.ValidoArancel === 1) {
      this.props.dispatch(ValidarGruposSolicitudEnCurso(
        () => this.ModalConfirmarSolicitarReajusteAux(true),
        () => this.ModalSolicitudEnCursoAux(true)
      ));
      if (this.props.replicaArancel === 1) {
        this.props.dispatch(IniciarValidacionesReplicacionSolicitud());
      }
    } if (this.props.periodoReajustePQ.ValidoPaquetes === 1) {
      this.props.dispatch(ValidarGruposSolicitudEnCursoPQ(
        () => this.ModalConfirmarSolicitarReajusteAux(true),
        () => this.ModalSolicitudEnCursoAux(true)
      ));
      if (this.props.replicaPaquetes === 1) {
        this.props.dispatch(IniciarValidacionesReplicacionSolicitudPQ());
      }
    }
  }

  ModalSolicitudReajuste = () => {
    this.props.dispatch(ModalSolicitudReajustePaso(1));
    this.props.dispatch(CargarSolicitudesEnCurso(null));
    this.props.dispatch(CargarSolicitudesEnCursoReplicaArancel(null));
    this.props.dispatch(CargarVigenciasNoExistentesReplica(null));
    this.props.dispatch(SetLoadingValidacionSolicitudEnCurso(true));
    this.props.dispatch(LoadingValidacion(false));
  }

  ModalSolicitudReajusteRespuesta = () => {
    if (this.props.ENV.ENVIAR_SOLICITUD_CUANDO_EXISTE_EN_CURSO) {
      this.props.dispatch(ModalConfirmarSolicitarReajuste(true));
    } else {
      if (this.state.modalSolicitudEnCursoAux === true || this.props.loadingValidacionSolicitudEnCurso === false) {
        this.ModalSolicitudEnCurso(true);
      } else {
        this.props.dispatch(ModalConfirmarSolicitarReajuste(true));
      }
    }
  }

  CloseModalConfirmacion = () => {
    this.props.dispatch(ModalConfirmarSolicitarReajuste(false));
  }

  Paso3 = () => {
    this.props.dispatch(ModalConfirmarSolicitarReajuste(false));
    this.props.dispatch(ModalSolicitudReajustePaso(3));
  }

  RealizarSolicitudReajuste = () => {
    if (this.props.periodoReajuste.ValidoArancel === 1) {
      this.props.dispatch(InsertReajuste());
    }
    if (this.props.periodoReajustePQ.ValidoPaquetes === 1) {
      this.props.dispatch(InsertReajustePQ());
    }
    this.props.dispatch(ModalConfirmarSolicitarReajuste(false));
    this.props.dispatch(ModalSolicitudReajustePaso(3));
  }

  CerrarModalConfirmacion = () => {
    this.props.dispatch(ModalConfirmarSolicitarReajuste(false));
  }

  modalAceptarClose = () => {
    this.props.dispatch(CambiarItemsEliminados(0));
    this.props.dispatch(ModalAceptarOpen(false));
  }

  ModalSolicitudEnCurso = (valor) => {
    this.setState({ modalSolicitudEnCurso: valor });
  }

  ModalSolicitudEnCursoAux = (valor) => {
    this.setState({ modalSolicitudEnCursoAux: valor });
  }

  ModalConfirmarSolicitarReajusteAux = (valor) => {
    this.setState({ modalConfirmarSolicitarReajusteAux: valor });
  }

  render() {
    const menuItemsSolicitudReajuste = [];
    this.props.itemsSolicitudReajuste.map((item) => (
      menuItemsSolicitudReajuste.push((
        <TableRow key={item.key}>
          <TableRowColumn>{this.props.rutInstitucion}</TableRowColumn>
          <TableRowColumn>{item.tiposArancel}</TableRowColumn>
          <TableRowColumn>{item.centrosAtencion}</TableRowColumn>
          <TableRowColumn>{item.tiposPrestaciones}</TableRowColumn>
        </TableRow>
      ))
    ));

    const menuItemsSolicitudReajustePQ = [];
    this.props.itemsSolicitudReajustePQ.map((item) => (
      menuItemsSolicitudReajustePQ.push((
        <TableRow key={item.key}>
          <TableRowColumn>{this.props.rutInstitucion}</TableRowColumn>
          <TableRowColumn>{item.tiposArancel}</TableRowColumn>
          <TableRowColumn>{item.vigencias}</TableRowColumn>
        </TableRow>
      ))
    ));

    const actionModalConfirmacion = [
      <FlatButton
        label="Volver"
        primary
        onClick={this.CerrarModalConfirmacion}
      />,
      <FlatButton
        label="Continuar"
        onClick={this.RealizarSolicitudReajuste}
      />,
    ];

    const actionModalAceptar = [
      <FlatButton
        label="Ok, Entendido"
        onClick={this.modalAceptarClose}
      />,
    ];

    return (
      <div style={{ width: 990 }}>
        <div style={styles.frameContenidoGeneral}>
          <Card zDepth={0} style={{ paddingBottom: 0 }}>
            <CardText style={{ paddingBottom: 0 }}>
              <div className="row" style={{ paddingBottom: 0 }}>
                <div className="col-12" style={{ margin: 0, padding: 0 }}>
                  <div style={styles.h1}>Solicitar Reajuste por IPC
                  </div>
                  <div style={styles.h2}>
                    Este reajuste se realizará sobre todos los grupos de prestación seleccionados.
                    En caso de que desee realizar modificaciones, deberá solicitarlas y luego de tener
                    una resolución de la Isapre, teniendo los valores cargados y actualizados,
                    usted deberá solicitar el reajuste. Lo mismo se aplica para paquetes quirúrgicos.
                  </div>
                  <br></br>
                  <div style={styles.h3}>Rut Institución: {this.props.rutInstitucion}
                  </div>
                </div>
              </div>

              {this.props.periodoReajuste.ValidoArancel === 1 ?

                <div style={{ padding: "5px" }}>
                  <Card
                    initiallyExpanded
                    zDepth={0}
                  >
                    <CardHeader
                      actAsExpander={false}
                      showExpandableButton
                      iconStyle={{ height: 30, width: 30, color: "#212121" }}
                      style={{
                        paddingTop: "0px", paddingBottom: "0px", maxWidth: "1290px", overflow: "hidden",
                      }}
                    >
                      <div style={styles.h1}>Reajuste Arancel
                      </div>
                    </CardHeader>
                    <CardText
                      expandable
                      style={{
                        paddingTop: "0px", paddingBottom: "0px", maxWidth: "990px", overflow: "auto",
                      }}
                    >
                      <div className="row" style={{ paddingBottom: 0, marginTop: 15, marginBottom: 10 }}>
                        <div className="col-3" style={styles.colSelectFieldActualizar}>
                          <div style={styles.tituloReajustarPrestacionIpc}>Valor a Reajustar
                          </div>
                          <div style={styles.datoReajustarPrestacionIpc}>{this.props.valorReajuste} %
                          </div>
                        </div>
                        <div className="col-3" style={styles.colSelectFieldActualizar}>
                          <div style={styles.tituloReajustarPrestacionIpc}>Inicio Vigencia
                          </div>
                          <div style={styles.datoReajustarPrestacionIpc}>{this.props.vigenciaReajuste.toLocaleDateString()}
                          </div>
                        </div>
                        <div className="col-3" style={styles.colSelectFieldActualizar}>
                          <div style={styles.tituloReajustarPrestacionIpc}>Observaciones
                          </div>
                          <div style={styles.datoReajustarPrestacionIpc}>{this.props.comentario}
                          </div>
                        </div>
                        <div className="col-3" style={styles.colSelectFieldActualizar}>
                          <div style={styles.tituloReajustarPrestacionIpc}>Replicar otra Isapre
                          </div>
                          <div style={styles.datoReajustarPrestacionIpc}>{this.props.replicaArancel === 2 ? "No" : "Sí"}
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col" >
                          {this.props.modalSolicitudReajusteConfirmacionLoading ?
                            <div className="row justify-content-center">
                              <div className="col-2">
                                <CircularProgress />
                              </div>
                            </div>
                            :
                            <Table
                              key="tablaSolicitudConfirmacion"
                              fixedHeader
                              fixedFooter
                              selectable={false}
                              height="400px"
                            >
                              <TableHeader
                                adjustForCheckbox={false}
                                displaySelectAll={false}
                              >
                                <TableRow selectable={false} >
                                  <TableHeaderColumn style={styles.formatColumnHeader} >Rut Institución</TableHeaderColumn>
                                  <TableHeaderColumn style={styles.formatColumnHeader} >Tipo de Arancel</TableHeaderColumn>
                                  <TableHeaderColumn style={styles.formatColumnHeader} >Centro de Atención</TableHeaderColumn>
                                  <TableHeaderColumn style={styles.formatColumnHeader} >Tipo de Prestación</TableHeaderColumn>
                                </TableRow>
                              </TableHeader>
                              <TableBody
                                displayRowCheckbox={false}
                                deselectOnClickaway={false}
                                showRowHover
                                stripedRows={false}
                              >
                                {menuItemsSolicitudReajuste}
                              </TableBody>
                            </Table>
                          }
                        </div>
                      </div>
                    </CardText>
                  </Card>
                </div>
                : null}

              {this.props.periodoReajustePQ.ValidoPaquetes === 1 ?

                <div style={{ padding: "5px" }}>
                  <Card
                    initiallyExpanded
                    zDepth={0}
                  >
                    <CardHeader
                      actAsExpander={false}
                      showExpandableButton
                      iconStyle={{ height: 30, width: 30, color: "#212121" }}
                      style={{
                        paddingTop: "0px", paddingBottom: "0px", maxWidth: "1290px", overflow: "hidden",
                      }}
                    >
                      <div style={styles.h1}>Reajuste Paquetes
                      </div>
                    </CardHeader>
                    <CardText
                      expandable
                      style={{
                        paddingTop: "0px", paddingBottom: "0px", maxWidth: "990px", overflow: "auto",
                      }}
                    >
                      <div className="row" style={{ paddingBottom: 0, marginTop: 15, marginBottom: 10 }}>
                        <div className="col-3" style={styles.colSelectFieldActualizar}>
                          <div style={styles.tituloReajustarPrestacionIpc}>Valor a Reajustar
                          </div>
                          <div style={styles.datoReajustarPrestacionIpc}>{this.props.valorReajustePaquetes} %
                          </div>
                        </div>
                        <div className="col-3" style={styles.colSelectFieldActualizar}>
                          <div style={styles.tituloReajustarPrestacionIpc}>Inicio Vigencia
                          </div>
                          <div style={styles.datoReajustarPrestacionIpc}>{this.props.vigenciaReajustePQ.toLocaleDateString()}
                          </div>
                        </div>
                        <div className="col-3" style={styles.colSelectFieldActualizar}>
                          <div style={styles.tituloReajustarPrestacionIpc}>Observaciones
                          </div>
                          <div style={styles.datoReajustarPrestacionIpc}>{this.props.comentarioPQ}
                          </div>
                        </div>
                        <div className="col-3" style={styles.colSelectFieldActualizar}>
                          <div style={styles.tituloReajustarPrestacionIpc}>Replicar otra Isapre
                          </div>
                          <div style={styles.datoReajustarPrestacionIpc}>{this.props.replicaPaquetes === 2 ? "No" : "Sí"}
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col" >
                          {this.props.modalSolicitudReajusteConfirmacionLoading ?
                            <div className="row justify-content-center">
                              <div className="col-2">
                                <CircularProgress />
                              </div>
                            </div>
                            :
                            <Table
                              key="tablaSolicitudConfirmacionPQ"
                              fixedHeader
                              fixedFooter
                              selectable={false}
                              height="400px"
                            >
                              <TableHeader
                                adjustForCheckbox={false}
                                displaySelectAll={false}
                              >
                                <TableRow selectable={false} >
                                  <TableHeaderColumn style={styles.formatColumnHeader} >Rut Institución</TableHeaderColumn>
                                  <TableHeaderColumn style={styles.formatColumnHeader} >Tipo de Arancel</TableHeaderColumn>
                                  <TableHeaderColumn style={styles.formatColumnHeader} >Fecha de Vigencia a Reajustar</TableHeaderColumn>
                                </TableRow>
                              </TableHeader>
                              <TableBody
                                displayRowCheckbox={false}
                                deselectOnClickaway={false}
                                showRowHover
                                stripedRows={false}
                              >
                                {menuItemsSolicitudReajustePQ}
                              </TableBody>
                            </Table>
                          }
                        </div>
                      </div>
                    </CardText>
                  </Card>
                </div>
                : null}


              <div className="row" style={{ paddingBottom: 0, marginTop: 10, marginBottom: 20 }}>
                <div className="col-12" style={{ margin: 0, padding: 0 }}>
                  <div style={styles.h2}>
                    * El reajuste se aplicará a los valores totales cargados en la isapre, señalados anteriormente.
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-6" style={{ textAlign: "left", marginTop: 10, marginBottom: 10 }}>
                  <RaisedButton
                    label="Volver atrás"
                    onClick={this.ModalSolicitudReajuste}
                    icon={<i className="material-icons">keyboard_arrow_left</i>}
                    backgroundColor="#fff"
                    overlayStyle={{ borderRadius: 5 }}
                    labelStyle={{
                      fontSize: "11px", color: "#757575", paddingLeft: 10, paddingRight: 5,
                    }}
                    style={{ width: "145px", borderRadius: 5 }}
                    buttonStyle={{ border: "2px solid #C3C3C3", borderRadius: 5 }}
                  />
                </div>
                <div className="col-6" style={{ textAlign: "right", marginTop: 10, marginBottom: 10 }}>
                  {!this.props.loading ?
                    <RaisedButton
                      label="Confirmar solicitud de reajuste"
                      onClick={this.ModalSolicitudReajusteRespuesta}
                      secondary
                      labelStyle={{ fontSize: "11px" }}
                      overlayStyle={{ borderRadius: 5 }}
                      rippleStyle={{ borderRadius: 5 }}
                      style={{ width: "250px", borderRadius: 5, marginLeft: 20 }}
                      buttonStyle={{ borderRadius: 5 }}
                      disabled={this.props.loading}
                    />
                    :
                    <RaisedButton
                      label="Cargando ..."
                      secondary
                      labelStyle={{ fontSize: "11px" }}
                      overlayStyle={{ borderRadius: 5 }}
                      rippleStyle={{ borderRadius: 5 }}
                      style={{ width: "250px", borderRadius: 5, marginLeft: 20 }}
                      buttonStyle={{ borderRadius: 5 }}
                    />
                  }
                </div>
              </div>
            </CardText>
          </Card>
        </div>

        {/* <HistorialReajustes /> */}

        <Dialog
          key="dialogAceptarSolicitud"
          id="dialogAceptarSolicitud"
          actions={actionModalConfirmacion}
          modal
          open={this.props.modalConfirmarSolicitud}
          style={{ fontSize: "13px" }}
          title={
            <div>
              <div style={{ float: "right" }}>
                <IconButton onClick={this.CloseModalConfirmacion} >
                  <i className="material-icons" style={{ color: "#ffffff" }}>close</i>
                </IconButton>
              </div>
            </div>
          }
        >
          <div>
            <p>Se ha validado exitosamente que no tiene solicitudes pendientes.</p>
            <p>Se ha validado exitosamente que puede replicar las solicitudes seleccionadas.</p>
          </div>
          <div style={{ marginBottom: "5px" }}></div>
          <p>Este reajuste se aplicará sobre los valores vigentes en la isapre,
            al presionar continuar, se generará una solicitud de reajuste y no podrá modificarla.</p>
          <div style={{ marginBottom: "5px" }}></div>
          <p>¿Está seguro?</p>
        </Dialog>

        {/*<Dialog
          key="dialogModal"
          id="dialogConfimacionSolicitud"
          actions={actionModalAceptar}
          modal
          open={this.props.modalAceptar}
          style={{ fontSize: "13px" }}
          title={
            <div>
              <div style={{ float: "right" }}>
                <IconButton onClick={this.CloseModalConfirmacion} >
                  <i className="material-icons" style={{ color: "#ffffff" }}>close</i>
                </IconButton>
              </div>
            </div>
          }
        >
          {this.props.itemsSolicitudReajusteEliminados === 1 ? "El reajuste se aplicará según lo seleccionado." :
            `El reajuste se aplicará según lo seleccionado.`}
        </Dialog>*/}

        <Dialog
          key="dialogPrestacionesEnCurso"
          id="dialogPrestacionesEnCurso"
          actions={[
            <FlatButton
              label="Aceptar"
              onClick={() => this.ModalSolicitudEnCurso(false)}
            />,
          ]}
          modal
          open={this.state.modalSolicitudEnCurso}
          style={{ fontSize: "13px" }}
          title={
            <div>
              <div style={{ float: "right" }}>
                <IconButton onClick={() => this.ModalSolicitudEnCurso(false)} >
                  <i className="material-icons" style={{ color: "#ffffff" }}>close</i>
                </IconButton>
              </div>
            </div>
          }
        >
          {this.props.solicitudesPendientes.length > 0 ?
            <div>
              <p>Se detectaron solicitudes pendientes que impiden generar el reajuste. Para continuar se deben procesar las solicitudes.</p>
              <p>Las solicitudes pendientes son las siguientes: {this.props.solicitudesPendientes.sort(function (a, b) { return a - b }).join(', ')}. </p>
            </div>
            : null}
          <div style={{ marginBottom: "5px" }}></div>
          {!this.props.usuarioPuedeReplicar || !this.props.prestadorPuedeReplicar || this.props.solicitudesPendientesRepA.length > 0 || this.props.vigenciasNoEnReplica.length > 0 ?
            <p>Se detectaron inconsistencias para generar la réplica a la otra isapre. Si quiere continuar, debe solucionar los problemas o generar la solicitud marcando NO en réplicar. Los motivos que la impiden son los siguientes:</p>
            : null}
          {!this.props.usuarioPuedeReplicar ?
            <p>Usuario no tiene acceso en la otra isapre, no puede replicar.</p>
            : null}
          {!this.props.prestadorPuedeReplicar ?
            <p>Prestador no tiene acceso en la otra isapre, no puede replicar.</p>
            : null}
          {this.props.vigenciasNoEnReplica.length > 0 ?
            <p>Las siguientes vigencias seleccionadas en la Solicitud de Paquetes no existen en la Isapre a replicar: {this.props.vigenciasNoEnReplica.sort(function (a, b) { return a - b }).join(', ')}.</p>
            : null}
          {this.props.solicitudesPendientesRepA.length > 0 ?
            <p>Solicitudes pendientes en la otra Isapre: {this.props.solicitudesPendientesRepA.sort(function (a, b) { return a - b }).join(', ')}. </p>
            : null}
        </Dialog>

      </div>
    );
  }
}

SolicitudReajusteConfirmacion.propTypes = {
  loading: PropTypes.bool.isRequired,
  rutInstitucion: PropTypes.number.isRequired,
  valorReajuste: PropTypes.number.isRequired,
  valorReajustePaquetes: PropTypes.number.isRequired,
  comentario: PropTypes.string.isRequired,
  comentarioPQ: PropTypes.string.isRequired,
  modalConfirmarSolicitud: PropTypes.bool.isRequired,
  periodoReajuste: PropTypes.any.isRequired,
  periodoReajustePQ: PropTypes.any.isRequired,
  dispatch: PropTypes.func.isRequired,
  itemsSolicitudReajuste: PropTypes.array.isRequired,
  itemsSolicitudReajustePQ: PropTypes.array.isRequired,
  itemsSolicitudReajusteEliminados: PropTypes.number.isRequired,
  modalSolicitudReajusteConfirmacionLoading: PropTypes.bool.isRequired,
  modalAceptar: PropTypes.bool.isRequired,
  vigenciaReajuste: PropTypes.any.isRequired,
  vigenciaReajustePQ: PropTypes.any.isRequired,
  replicaArancel: PropTypes.number.isRequired,
  replicaPaquetes: PropTypes.number.isRequired,
  solicitudesPendientes: PropTypes.array,
  solicitudesPendientesRepA: PropTypes.array,
  vigenciasNoEnReplica: PropTypes.array,
  loadingValidacionSolicitudEnCurso: PropTypes.bool.isRequired,
  usuarioPuedeReplicar: PropTypes.bool.isRequired,
  prestadorPuedeReplicar: PropTypes.bool.isRequired,
  ENV: PropTypes.any.isRequired,
};

const mapStateToProps = (state) => ({
  modalSolicitudReajusteConfirmacionLoading: state.solicitudReajuste.modalSolicitudReajusteConfirmacionLoading,
  loading: state.solicitudReajuste.loading,
  loading2: state.filtroBusquedaRA.loading,
  rutInstitucion: state.global.rutInstitucion,
  valorReajuste: state.solicitudReajuste.valorReajuste,
  valorReajustePaquetes: state.solicitudReajuste.valorReajustePaquetes,
  comentario: state.solicitudReajuste.comentario,
  comentarioPQ: state.solicitudReajuste.comentarioPQ,
  replicaArancel: state.solicitudReajuste.replicaArancel,
  replicaPaquetes: state.solicitudReajuste.replicaPaquetes,
  modalConfirmarSolicitud: state.solicitudReajuste.modalConfirmarSolicitud,
  itemsSolicitudReajuste: state.solicitudReajuste.itemsSolicitudReajuste,
  itemsSolicitudReajustePQ: state.solicitudReajuste.itemsSolicitudReajustePQ,

  itemsSolicitudReajusteEliminados: state.solicitudReajuste.itemsSolicitudReajusteEliminados,
  modalAceptar: state.solicitudReajuste.modalAceptar,
  periodoReajuste: state.filtroBusquedaRA.periodoReajuste,
  periodoReajustePQ: state.filtroBusquedaRA.periodoReajustePQ,
  vigenciaReajuste: state.solicitudReajuste.vigenciaReajuste,
  vigenciaReajustePQ: state.solicitudReajuste.vigenciaReajustePQ,
  solicitudesPendientes: state.solicitudReajuste.solicitudesPendientes,
  solicitudesPendientesRepA: state.solicitudReajuste.solicitudesPendientesRepA,
  usuarioPuedeReplicar: state.solicitudReajuste.usuarioPuedeReplicar,
  prestadorPuedeReplicar: state.solicitudReajuste.prestadorPuedeReplicar,
  loadingValidacionSolicitudEnCurso: state.solicitudReajuste.loadingValidacionSolicitudEnCurso,
  vigenciasNoEnReplica: state.solicitudReajuste.vigenciasNoEnReplica,
  ENV: state.global.ENV,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});


export default connect(mapStateToProps, mapDispatchToProps)(SolicitudReajusteConfirmacion);




// WEBPACK FOOTER //
// ./src/components/ReajustarArancel/SolicitudReajusteConfirmacion/view.jsx